import React from "react";

import { InfoSmIcon } from "@packages/ds";

import { IconControl } from "ds/Button";
import Dialog from "ds/Dialog";

// TODO DELETE THIS COMPONENT WHEN HTTP METRICS IS MERGED AND USE THE
// COMPONENT THERE TO PREVENT DUPLICATE

type InfoProps = {
  title?: string;
  description?: string;
  link?: React.ReactNode;
  align?: "start" | "center" | "end";
};

const ChartInfo = (prop: InfoProps) => {
  return (
    <Dialog
      title={prop.title}
      description={prop.description}
      link={prop.link}
      align={prop.align}
      trigger={
        <IconControl aria-label="info-trigger-chart-info">
          <InfoSmIcon />
        </IconControl>
      }
    />
  );
};

export default ChartInfo;
